import { useMemo, useState } from 'react';
import { useCurrentUserType } from './useCurrentUserType';
import { useApprovalStepsInfo } from './useApprovalStepsInfo';
import { useCurrentUser } from './useCurrentUser';
import { useGetHasScope } from './useGetHasScope';
import { useHasApprovalScope } from './useHasApprovalScope';
import { getAvailableOperations } from '../utils/getAvailableOperations';
import { getUserCanSkip } from '../utils/getUserCanSkip';
export const useApprovalMeta = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  isFetchingApprovableObjectId,
  hasErrorFetchingApprovableObjectId,
  approvalObjectIds,
  assetName,
  approvalData,
  approvalConfig,
  restartOnConclude = false
}) => {
  var _availableOperations$;
  const [currentOperation, setCurrentOperation] = useState(null);
  const [currentStepId, setCurrentStepId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showApprovalEditPanel, setShowApprovalEditPanel] = useState(false);
  const currentUser = useCurrentUser();
  const hasScope = useGetHasScope();
  const isSuperAdmin = hasScope('super-admin');
  const hasApproveScope = useHasApprovalScope(approvalType, 'approve');
  const currentUserType = useCurrentUserType(approvalData.data, currentUser);
  const {
    stepCount,
    approvedCount,
    pendingCount,
    stepStatusForCurrentUser
  } = useApprovalStepsInfo(approvalData.data ? approvalData.data.approvalSteps : [], (currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_id) != null ? String(currentUser.user_id) : undefined);
  const isLoading = useMemo(() => {
    return approvalData.isLoading || approvalConfig.isLoading;
  }, [approvalConfig, approvalData]);
  const availableOperations = useMemo(() => getAvailableOperations({
    configEnabled: approvalConfig.config.enabled,
    isLoading,
    approvalStatus: approvalData.data ? approvalData.data.approvalStatus : undefined,
    approvalConcluded: approvalData.data ? approvalData.data.approvalConcluded : undefined,
    hasApprovalData: approvalData.data !== null,
    currentUserType,
    stepStatusForCurrentUser,
    hasApproveScope,
    approvalType,
    restartOnConclude
  }), [approvalConfig.config.enabled, isLoading, approvalData.data, currentUserType, stepStatusForCurrentUser, hasApproveScope, approvalType, restartOnConclude]);

  // @deprecated — use availableOperations instead. Kept for backward compat
  // with external consumers (e.g. ContentEditorUI).
  const approvalOperation = (_availableOperations$ = availableOperations[0]) !== null && _availableOperations$ !== void 0 ? _availableOperations$ : null;
  const userCanSkipThisApproval = useMemo(() => getUserCanSkip({
    approvalStatus: approvalData.data ? approvalData.data.approvalStatus : undefined,
    hasApprovalData: approvalData.data !== null,
    isSuperAdmin,
    skipApprovalOption: approvalConfig.config.skipApprovalOption,
    usersIdsListThatCanSkipApproval: approvalConfig.config.usersIdsListThatCanSkipApproval,
    currentUserId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_id
  }), [approvalData, approvalConfig, currentUser, isSuperAdmin]);
  const httpErrors = {
    fetchData: approvalData.fetchError,
    hasFetchConfigError: approvalConfig.hasFetchError,
    hasFetchApproverUsersError: approvalData.hasFetchApproverUsersError
  };
  return {
    approvableObjectId,
    isFetchingApprovableObjectId,
    hasErrorFetchingApprovableObjectId,
    approvalObjectIds,
    approvalAction,
    approvalOperation,
    availableOperations,
    approvalType,
    approvedCount,
    assetName,
    currentUser,
    currentUserType,
    httpErrors,
    isLoading,
    isSuperAdmin,
    currentOperation,
    currentStepId,
    pendingCount,
    restartOnConclude,
    setCurrentOperation,
    setCurrentStepId,
    setShowModal,
    setShowApprovalEditPanel,
    showApprovalEditPanel,
    showModal,
    stepCount,
    stepStatusForCurrentUser,
    userCanSkipThisApproval,
    approvalStatus: approvalData.data ? approvalData.data.approvalStatus : undefined
  };
};